import React from 'react';
import { DetailList, IvaTag, MoneyTag } from '../../pages/sales/Sales.styles';
import { AttendeeList } from './sales.styles';
import { formatMoney } from '../../utils/money';
import { formatCalendarDate, formatTimestamp } from '../../utils/dates';
import { paymentMethodLabel } from './saleLabels';

// Lista de datos de una venta (ticket y detalle). Los CURP salen enmascarados
// (`curpMasked`): el backend nunca devuelve el CURP completo.
const SaleDetails = ({ sale, showSeller = true }) => {
  const customer = sale.customer || {};
  const attendees = sale.attendees || [];

  return (
    <>
      <DetailList>
        <div className="row"><dt>Actividad</dt><dd>{sale.activityName}</dd></div>
        {sale.activityLocation && <div className="row"><dt>Lugar</dt><dd>{sale.activityLocation}</dd></div>}
        <div className="row"><dt>Fecha y hora</dt><dd>{formatCalendarDate(sale.date)} · {sale.time}</dd></div>
        <div className="row"><dt>Lugares</dt><dd>{sale.quantity}</dd></div>
        <div className="row"><dt>Método de pago</dt><dd>{paymentMethodLabel(sale.paymentMethod)}</dd></div>
        <div className="row strong">
          <dt>Total</dt>
          <dd><MoneyTag>{formatMoney(sale.finalAmount)}</MoneyTag> <IvaTag>IVA incluido</IvaTag></dd>
        </div>
        {customer.name && <div className="row"><dt>Cliente</dt><dd>{customer.name}</dd></div>}
        {customer.email && <div className="row"><dt>Email</dt><dd>{customer.email}</dd></div>}
        {customer.phone && <div className="row"><dt>Teléfono</dt><dd>{customer.phone}</dd></div>}
        {sale.promoter && <div className="row"><dt>Promotor</dt><dd>{sale.promoter.name}</dd></div>}
        {showSeller && sale.soldBy && <div className="row"><dt>Vendió</dt><dd>{sale.soldBy}</dd></div>}
        {sale.createdAt && <div className="row"><dt>Registrada</dt><dd>{formatTimestamp(sale.createdAt)}</dd></div>}
        {sale.scannedAt && (
          <div className="row">
            <dt>Entró</dt>
            <dd>{formatTimestamp(sale.scannedAt)}{sale.scannedBy ? ` · ${sale.scannedBy}` : ''}</dd>
          </div>
        )}
        {sale.privacyNoticeAcceptedAt && (
          <div className="row"><dt>Aviso de privacidad</dt><dd>Aceptado el {formatTimestamp(sale.privacyNoticeAcceptedAt)}</dd></div>
        )}
        {sale.notes && <div className="row"><dt>Notas</dt><dd>{sale.notes}</dd></div>}
      </DetailList>

      {attendees.length > 0 && (
        <>
          <h3 style={{ fontSize: 'var(--text-base)', margin: '14px 0 4px' }}>Asistentes</h3>
          <AttendeeList>
            {attendees.map((a) => (
              <li key={a.position}>
                <span className="att-name">{a.position}. {a.name}</span>
                {a.hasCurp && <span className="att-curp">CURP {a.curpMasked}</span>}
              </li>
            ))}
          </AttendeeList>
        </>
      )}
    </>
  );
};

export default SaleDetails;
